import React 			from 'react';
import PropTypes 	from 'prop-types';
import BLComponent	from '../../core/_BLComponent.jsx';
import HiddenScroll 	from '../../common/_HiddenScroll.jsx';

export default class CrowdNavigation extends BLComponent {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		// const activeNav = this.nav.querySelector('.view-selector__item--active');
		// const navParent = this.nav.parentElement;

		// activeNav != null ? navParent.scrollLeft = activeNav.offsetLeft : 0;

		// this.initStickyNav();
	}

	render() {
		const {classes = ''} = this.props;
		return null;

		return (
			<HiddenScroll classes={"crowd-nav l-pad-right js-crowd-nav " + classes} ref={navContainer => this.navContainer = navContainer}>
				<ul ref={nav => this.nav = nav} className="view-selector view-selector--bordered l-border--null l-pad-x">
					<li className={"view-selector__item " + (this.props.page == 1 ? ' view-selector__item--active' : '')}>
						<a href={blapp.url2.getCrowdProjectMainUrl()} className="view-selector__item-content link--inherit">Current Programs</a>
					</li>
					<li className={"view-selector__item " + (this.props.page == 2 ? ' view-selector__item--active' : '')}>
						<a href={blapp.url2.getCrowdProjectGuidelinesUrl()} className="view-selector__item-content link--inherit">Submission Guidelines</a>
					</li>
					<li className={"view-selector__item " + (this.props.page == 6 ? ' view-selector__item--active' : '')}>
						<a href={blapp.url2.getCrowdProjectSubmissionsUrl()} className="view-selector__item-content link--inherit">My Submissions</a>
					</li>
					<li className={"view-selector__item " + (this.props.page == 3 ? ' view-selector__item--active' : '')}>
						<a href={blapp.url2.getCrowdProjectFAQUrl()} className="view-selector__item-content link--inherit">FAQs</a>
					</li>
					<li className={"view-selector__item "}>
						<a href={"https://forum.bricklink.com/viewforum.php?f=13&sid=24ac69d3ca1c299c473c58a1e9bf495e"} className="view-selector__item-content link--inherit">Forum</a>
					</li>
					<li className={"view-selector__item " + (this.props.page == 4 ? ' view-selector__item--active' : '')}>
						<a href={blapp.url2.getCrowdProjectTOSUrl()} className="view-selector__item-content link--inherit">Terms of Service</a>
					</li>
					<li className={"view-selector__item "}>
						<a href={'https://www.lego.com/en-gb/page/static/orders'} target="_blank" className="view-selector__item-content link--inherit">My Pre-orders<i className="far fa-external-link-square-alt l-margin-left--sm"/></a>
					</li>
				</ul>
			</HiddenScroll>
		);
	}

	initStickyNav() {
		const nav 			= document.querySelector('.js-crowd-nav');
		const navTop 		= nav.offsetTop;
		const navClone 	= nav.cloneNode(true);
					navClone.classList.add('crowd-nav--fixed');

		window.addEventListener('scroll', () => {
			const windowScroll = Math.round(window.scrollY);
			const stickyMainNav 			= document.querySelector('.scroll-header-visible .header');
			const stickyMainNavHeight = stickyMainNav ? stickyMainNav.offsetHeight : 0;

			if((windowScroll + stickyMainNavHeight) > navTop) {
				if(!document.querySelector('.crowd-nav--fixed')) {
					nav.before(navClone);
					nav.classList.add('.crowd-nav--fixed');
				}
			}else{
				navClone.remove();
				nav.classList.remove('.crowd-nav--fixed');
			}
		});
	}
}

CrowdNavigation.propTypes = {
		classes: PropTypes.string
}